//* 편리정보 허브 — 사이드바 마이페이지 > 계정관리 바로 아래 메뉴. 하위: 자주쓰는 장지 / 자주쓰는 상주말씀
import { FC } from 'react';

import { Icon } from '@shared/components/icons';
import { useAuth } from '@shared/state/hooks/useAuth';
import { Link } from 'react-router-dom';

import { readMyDetailList } from '../utils/myDetailList.util';
import { useTitleHook } from '../hooks/useTitleHook';

const PreferInfoPage: FC = () => {
  useTitleHook('편리정보');
  const { ChevronRight } = Icon();
  const { userProfile, bugoCamelRole } = useAuth();
  const camelRole = bugoCamelRole();
  const cemeteryCount = readMyDetailList(userProfile, camelRole, 'cemeteryList').length;
  const mournerTextCount = readMyDetailList(
    userProfile,
    camelRole,
    'mournerTextList',
  ).length;

  const row = (title: string, description: string, to: string, count: number) => (
    <Link to={to} className="flex items-center justify-between gap-3 py-4">
      <div className="min-w-0">
        <p className="text-15 font-bold">{title}</p>
        <p className="mt-0.5 break-keep text-12 leading-4 theme-text-8">{description}</p>
      </div>
      <div className="flex shrink-0 items-center gap-1 text-13 theme-text-8">
        <span>{count}개</span>
        <ChevronRight />
      </div>
    </Link>
  );

  return (
    <div className="space-y-4 px-4 py-4 text-sm">
      <div className="rounded-xl px-5 py-1 theme-bg-1">
        <div className="divide-y divide-gray-100">
          {row(
            '자주쓰는 상주말씀 관리',
            '부고 등록·수정의 상주 말씀 위에 바로 나타나 누르면 채워집니다.',
            '/user/prefer/mourner-text',
            mournerTextCount,
          )}
          {row(
            '자주쓰는 장지 관리',
            '부고 등록·수정의 장지 입력에서 바로 고를 수 있습니다.',
            '/user/prefer/cemetery',
            cemeteryCount,
          )}
        </div>
      </div>
    </div>
  );
};

export default PreferInfoPage;
